module.exports = __webpack_public_path__ + "img/2.08.thmb.e9eca208.jpg";